'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getMissingFieldErrorMessage", "ids", "hasMore", "offset", "query"];
import * as DSAssetFamilies from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';
import * as ObjectTypeIds from 'customer-data-filters/data/objectTypeIds';
import { List, Map as ImmutableMap } from 'immutable';
import { STRING } from 'customer-data-objects/property/PropertyTypes';
import { atomToPromise } from '../../../utilities/atomToPromise';
import { toDSFieldRecord } from 'customer-data-filters/filterQueryFormat/DSFieldRecord/toDSFieldRecord';
import { NONE } from '../../../filterQueryFormat/timestamps/TimestampTypes';
import ActivityTypeReferenceResolver from 'reference-resolvers/resolvers/ActivityTypeReferenceResolver';
import AdsFacebookAdgroupsReferenceResolver from 'reference-resolvers/resolvers/AdsFacebookAdgroupsReferenceResolver';
import AdsFacebookAdsReferenceResolver from 'reference-resolvers/resolvers/AdsFacebookAdsReferenceResolver';
import AdsFacebookCampaignsReferenceResolver from 'reference-resolvers/resolvers/AdsFacebookCampaignsReferenceResolver';
import AdsGoogleAdgroupsReferenceResolver from 'reference-resolvers/resolvers/AdsGoogleAdgroupsReferenceResolver';
import AdsGoogleAdsReferenceResolver from 'reference-resolvers/resolvers/AdsGoogleAdsReferenceResolver';
import AdsGoogleCampaignsReferenceResolver from 'reference-resolvers/resolvers/AdsGoogleCampaignsReferenceResolver';
import AdsGoogleKeywordsReferenceResolver from 'reference-resolvers/resolvers/AdsGoogleKeywordsReferenceResolver';
import AdsLinkedinAdgroupsReferenceResolver from 'reference-resolvers/resolvers/AdsLinkedinAdgroupsReferenceResolver';
import AdsLinkedinAdsReferenceResolver from 'reference-resolvers/resolvers/AdsLinkedinAdsReferenceResolver';
import AdsLinkedinCampaignsReferenceResolver from 'reference-resolvers/resolvers/AdsLinkedinCampaignsReferenceResolver';
import AdsPropertyReferenceResolver from 'reference-resolvers/resolvers/AdsPropertyReferenceResolver';
import AllWorkflowReferenceResolver from 'reference-resolvers/resolvers/AllWorkflowReferenceResolver';
import AutomationPlatformWorkflowResolver from 'reference-resolvers/resolvers/AutomationPlatformWorkflowReferenceResolver';
import CTAReferenceResolver from 'reference-resolvers/resolvers/CTAReferenceResolver';
import CallDispositionReferenceResolver from 'reference-resolvers/resolvers/CallDispositionReferenceResolver';
import MeetingOutcomeReferenceResolver from 'reference-resolvers/resolvers/MeetingOutcomeReferenceResolver';
import CompanyPropertyReferenceResolver from 'reference-resolvers/resolvers/CompanyPropertyReferenceResolver';
import CompanyReferenceResolver from 'reference-resolvers/resolvers/CompanyReferenceResolver';
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
import ContactListReferenceResolver from 'reference-resolvers/resolvers/ContactListReferenceResolver';
import ContactPropertyReferenceResolver from 'reference-resolvers/resolvers/ContactPropertyReferenceResolver';
import CtaToPlacementReferenceResolver from 'reference-resolvers/resolvers/CtaToPlacementReferenceResolver';
import CustomObjectReferenceResolver from 'reference-resolvers/resolvers/CustomObjectReferenceResolver';
import DealPropertyReferenceResolver from 'reference-resolvers/resolvers/DealPropertyReferenceResolver';
import EmailCampaignReferenceResolver from 'reference-resolvers/resolvers/EmailCampaignReferenceResolver';
import EmailCampaignUrlReferenceResolver from 'reference-resolvers/resolvers/EmailCampaignUrlReferenceResolver';
import EmailSubscriptionGroupsReferenceResolver from 'reference-resolvers/resolvers/EmailSubscriptionGroupsReferenceResolver';
import EmailSubscriptionReferenceResolver from 'reference-resolvers/resolvers/EmailSubscriptionReferenceResolver';
import EngagementPropertyReferenceResolver from 'reference-resolvers/resolvers/EngagementPropertyReferenceResolver';
import EventReferenceResolver from 'reference-resolvers/resolvers/EventReferenceResolver';
import FormBatchedReferenceResolver from 'reference-resolvers/resolvers/FormBatchedReferenceResolver';
import HierarchicalTeamReferenceResolver from 'reference-resolvers/resolvers/HierarchicalTeamReferenceResolver';
import InboundDbContactImportReferenceResolver from 'reference-resolvers/resolvers/InboundDbContactImportReferenceResolver';
import InboundDbImportReferenceResolver from 'reference-resolvers/resolvers/InboundDbImportReferenceResolver';
import IntegrationPropertyReferenceResolver from 'reference-resolvers/resolvers/IntegrationPropertyReferenceResolver';
import IntegrationReferenceResolver from 'reference-resolvers/resolvers/IntegrationReferenceResolver';
import LineItemPropertyReferenceResolver from 'reference-resolvers/resolvers/LineItemPropertyReferenceResolver';
import MediaBridgeReferenceResolver from 'reference-resolvers/resolvers/MediaBridgeReferenceResolver';
import MissingField from 'customer-data-filters/filterQueryFormat/MissingField';
import MultiCurrencyCurrencyCodeResolver from 'reference-resolvers/resolvers/MultiCurrencyCurrencyCodeResolver';
import ObjectDefinitionProvider from '../../../filterQueryFormat/objectDefinition/ObjectDefinitionProvider';
import OwnerPagedReferenceResolver from 'reference-resolvers/resolvers/OwnerPagedReferenceResolver';
import PersonaReferenceResolver from 'reference-resolvers/resolvers/PersonaReferenceResolver';
import PipelineReferenceResolver from 'reference-resolvers/resolvers/PipelineReferenceResolver';
import PipelineStageReferenceResolver from 'reference-resolvers/resolvers/PipelineStageReferenceResolver';
import ProductPropertyReferenceResolver from 'reference-resolvers/resolvers/ProductPropertyReferenceResolver';
import PropertyGroupReferenceResolver from 'reference-resolvers/resolvers/PropertyGroupReferenceResolver';
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
import QuotePropertyReferenceResolver from 'reference-resolvers/resolvers/QuotePropertyReferenceResolver';
import SalesforceCampaignReferenceResolver from 'reference-resolvers/resolvers/SalesforceCampaignReferenceResolver';
import SiteContentReferenceResolver from 'reference-resolvers/resolvers/SiteContentReferenceResolver';
import SocialChannelReferenceResolver from 'reference-resolvers/resolvers/SocialChannelReferenceResolver';
import SurveyMonkeyQuestionReferenceResolver from 'reference-resolvers/resolvers/SurveyMonkeyQuestionReferenceResolver';
import SurveyMonkeySettingReferenceResolver from 'reference-resolvers/resolvers/SurveyMonkeySettingReferenceResolver';
import SurveyReferenceResolver from 'reference-resolvers/resolvers/SurveyReferenceResolver';
import TicketPipelinesReferenceResolver from 'reference-resolvers/resolvers/TicketPipelinesReferenceResolver';
import TicketPropertyReferenceResolver from 'reference-resolvers/resolvers/TicketPropertyReferenceResolver';
import TicketStagesReferenceResolver from 'reference-resolvers/resolvers/TicketStagesReferenceResolver';
import UserReferenceResolver from 'reference-resolvers/resolvers/UserReferenceResolver';
import WebinarReferenceResolver from 'reference-resolvers/resolvers/WebinarReferenceResolver';
import WebinarSettingReferenceResolver from 'reference-resolvers/resolvers/WebinarSettingReferenceResolver';
import createDSAdapter from './createDSAdapter';
import get from 'transmute/get';
import identity from 'transmute/identity';
import indexBy from 'transmute/indexBy';
import memoize from 'transmute/memoize';
import { getResolverForObject } from '../getResolverForObject';
import InboundDbListsReferenceResolver from 'reference-resolvers/resolvers/InboundDbListsReferenceResolver';
import { getDynamicFilterFamilyBasis, parseDynamicFilterFamilyId, testDynamicFilterFamily } from '../../../filterQueryFormat/DynamicFilterFamilies';
import * as FiltersReferenceObjectTypes from '../../../data/FiltersReferenceObjectTypes';
const isSearchResolver = resolver => {
  return typeof resolver.search === 'function';
};
const lastQueries = {};
export const resetLastQueries = () => {
  Object.keys(lastQueries).forEach(key => delete lastQueries[key]);
};
const isQueryChanged = (query, lastQuery) => !!((query || lastQuery) && query !== lastQuery);
const getLastQuery = (referenceObjectType, resolver) => {
  if (isSearchResolver(resolver)) {
    return lastQueries[referenceObjectType];
  }
  return undefined;
};
export const getObjectDefinitionsResolverMap = () => ObjectDefinitionProvider.getAll().reduce((acc, objectDefinition) => {
  const {
    referenceObjectType
  } = objectDefinition;
  return Object.assign({}, acc, {
    [referenceObjectType]: objectDefinition.getPropertyResolver()
  });
}, {});
const resolverMap = Object.assign({
  [ReferenceObjectTypes.ACTIVITY_TYPE]: ActivityTypeReferenceResolver,
  [ReferenceObjectTypes.ADS_FACEBOOK_AD]: AdsFacebookAdsReferenceResolver,
  [ReferenceObjectTypes.ADS_FACEBOOK_ADGROUP]: AdsFacebookAdgroupsReferenceResolver,
  [ReferenceObjectTypes.ADS_FACEBOOK_CAMPAIGN]: AdsFacebookCampaignsReferenceResolver,
  [ReferenceObjectTypes.ADS_GOOGLE_AD]: AdsGoogleAdsReferenceResolver,
  [ReferenceObjectTypes.ADS_GOOGLE_ADGROUP]: AdsGoogleAdgroupsReferenceResolver,
  [ReferenceObjectTypes.ADS_GOOGLE_CAMPAIGN]: AdsGoogleCampaignsReferenceResolver,
  [ReferenceObjectTypes.ADS_GOOGLE_KEYWORD]: AdsGoogleKeywordsReferenceResolver,
  [ReferenceObjectTypes.ADS_LINKEDIN_AD]: AdsLinkedinAdsReferenceResolver,
  [ReferenceObjectTypes.ADS_LINKEDIN_ADGROUP]: AdsLinkedinAdgroupsReferenceResolver,
  [ReferenceObjectTypes.ADS_LINKEDIN_CAMPAIGN]: AdsLinkedinCampaignsReferenceResolver,
  [ReferenceObjectTypes.ADS_PROPERTY]: AdsPropertyReferenceResolver,
  [ReferenceObjectTypes.ALL_WORKFLOW]: AllWorkflowReferenceResolver,
  [ReferenceObjectTypes.AUTOMATION_PLATFORM_WORKFLOWS]: AutomationPlatformWorkflowResolver,
  [ReferenceObjectTypes.CALL_DISPOSITION]: CallDispositionReferenceResolver,
  [ReferenceObjectTypes.COMPANY_PROPERTY]: CompanyPropertyReferenceResolver,
  [ReferenceObjectTypes.COMPANY]: CompanyReferenceResolver,
  [ReferenceObjectTypes.CONTACT_LIST]: ContactListReferenceResolver,
  [ReferenceObjectTypes.CONTACT_PROPERTY]: ContactPropertyReferenceResolver,
  [ReferenceObjectTypes.CTA_TO_PLACEMENT]: CtaToPlacementReferenceResolver,
  [ReferenceObjectTypes.CTA]: CTAReferenceResolver,
  [ReferenceObjectTypes.CUSTOM_OBJECT]: resolversCache => () => ({
    resolversCache,
    resolverFactory: CustomObjectReferenceResolver
  }),
  [ReferenceObjectTypes.DEAL_PIPELINE_STAGE]: PipelineStageReferenceResolver,
  [ReferenceObjectTypes.DEAL_PIPELINE]: PipelineReferenceResolver,
  [ReferenceObjectTypes.DEAL_PROPERTY]: DealPropertyReferenceResolver,
  [ReferenceObjectTypes.EMAIL_CAMPAIGN_URL]: EmailCampaignUrlReferenceResolver,
  [ReferenceObjectTypes.EMAIL_CAMPAIGN]: EmailCampaignReferenceResolver,
  [ReferenceObjectTypes.EMAIL_SUBSCRIPTION]: EmailSubscriptionReferenceResolver,
  [ReferenceObjectTypes.EMAIL_SUBSCRIPTION_GROUPS]: EmailSubscriptionGroupsReferenceResolver,
  [ReferenceObjectTypes.ENGAGEMENT_PROPERTY]: EngagementPropertyReferenceResolver,
  [ReferenceObjectTypes.EVENT]: EventReferenceResolver,
  [ReferenceObjectTypes.FORM]: FormBatchedReferenceResolver,
  [ReferenceObjectTypes.HIERARCHICAL_TEAM]: HierarchicalTeamReferenceResolver,
  [ReferenceObjectTypes.INBOUND_DB_CONTACT_IMPORT]: InboundDbContactImportReferenceResolver,
  [ReferenceObjectTypes.INBOUND_DB_IMPORT]: resolversCache => () => ({
    resolversCache,
    resolverFactory: InboundDbImportReferenceResolver
  }),
  [ReferenceObjectTypes.INTEGRATION_PROPERTY]: IntegrationPropertyReferenceResolver,
  [ReferenceObjectTypes.INTEGRATION]: IntegrationReferenceResolver,
  [ReferenceObjectTypes.LINE_ITEM_PROPERTY]: LineItemPropertyReferenceResolver,
  [ReferenceObjectTypes.MULTI_CURRENCY_CURRENCY_CODE]: MultiCurrencyCurrencyCodeResolver,
  [ReferenceObjectTypes.OWNER]: OwnerPagedReferenceResolver,
  [ReferenceObjectTypes.PERSONA]: PersonaReferenceResolver,
  [ReferenceObjectTypes.PRODUCT_PROPERTY]: ProductPropertyReferenceResolver,
  [ReferenceObjectTypes.PROPERTY_GROUP]: PropertyGroupReferenceResolver,
  [ReferenceObjectTypes.QUOTE_PROPERTY]: QuotePropertyReferenceResolver,
  [ReferenceObjectTypes.SALESFORCE_CAMPAIGN]: SalesforceCampaignReferenceResolver,
  [ReferenceObjectTypes.SITE_CONTENT]: SiteContentReferenceResolver,
  [ReferenceObjectTypes.SURVEY_QUESTION]: SurveyMonkeyQuestionReferenceResolver,
  [ReferenceObjectTypes.SURVEY_SETTING]: SurveyMonkeySettingReferenceResolver,
  [ReferenceObjectTypes.SURVEY]: SurveyReferenceResolver,
  [ReferenceObjectTypes.TICKET_PIPELINE]: TicketPipelinesReferenceResolver,
  [ReferenceObjectTypes.TICKET_PROPERTY]: TicketPropertyReferenceResolver,
  [ReferenceObjectTypes.TICKET_STAGE]: TicketStagesReferenceResolver,
  [ReferenceObjectTypes.USER]: UserReferenceResolver,
  [ReferenceObjectTypes.WEBINAR_SETTING]: WebinarSettingReferenceResolver,
  [ReferenceObjectTypes.WEBINAR]: WebinarReferenceResolver,
  [ReferenceObjectTypes.MEETING_OUTCOME]: MeetingOutcomeReferenceResolver,
  [ReferenceObjectTypes.MEDIA_BRIDGE_MEDIA_OBJECT]: MediaBridgeReferenceResolver,
  [ReferenceObjectTypes.SOCIAL_CHANNEL]: SocialChannelReferenceResolver,
  [FiltersReferenceObjectTypes.MARKETING_EVENT_COORDINATES]: getResolverForObject(ObjectTypeIds.MARKETING_EVENT_TYPE_ID),
  [FiltersReferenceObjectTypes.CAMPAIGN_COORDINATES]: getResolverForObject(ObjectTypeIds.CAMPAIGN_TYPE_ID),
  [FiltersReferenceObjectTypes.WEB_INTERACTIVE_COORDINATES]: getResolverForObject(ObjectTypeIds.WEB_INTERACTIVE)
}, getObjectDefinitionsResolverMap(), {
  [ReferenceObjectTypes.INBOUND_DB_LISTS]: InboundDbListsReferenceResolver
});

// This map should only contain mappings for asset families that will be
// fetched directly. Data that is just used but not fetched directly with `fetch`
// (i.e. teams, owners, etc.) should only be in resolverMap.
const objectToReferenceType = Object.assign({
  [DSAssetFamilies.ADS_PROPERTY]: ReferenceObjectTypes.ADS_PROPERTY,
  [DSAssetFamilies.COMPANY_PROPERTY]: ReferenceObjectTypes.COMPANY_PROPERTY,
  [DSAssetFamilies.CONTACT_IMPORT]: ReferenceObjectTypes.INBOUND_DB_CONTACT_IMPORT,
  [DSAssetFamilies.CONTACT_LIST]: ReferenceObjectTypes.CONTACT_LIST,
  [DSAssetFamilies.CONTACT_PROPERTY]: ReferenceObjectTypes.CONTACT_PROPERTY,
  [DSAssetFamilies.CTA]: ReferenceObjectTypes.CTA,
  [DSAssetFamilies.CTA_TO_PLACEMENT]: ReferenceObjectTypes.CTA_TO_PLACEMENT,
  [DSAssetFamilies.DEAL_PROPERTY]: ReferenceObjectTypes.DEAL_PROPERTY,
  [DSAssetFamilies.EMAIL_CAMPAIGN]: ReferenceObjectTypes.EMAIL_CAMPAIGN,
  [DSAssetFamilies.EMAIL_SUBSCRIPTION]: ReferenceObjectTypes.EMAIL_SUBSCRIPTION,
  [DSAssetFamilies.ENGAGEMENT_PROPERTY]: ReferenceObjectTypes.ENGAGEMENT_PROPERTY,
  [DSAssetFamilies.EVENT]: ReferenceObjectTypes.EVENT,
  [DSAssetFamilies.FORM]: ReferenceObjectTypes.FORM,
  [DSAssetFamilies.GOTO_WEBINAR_SETTING]: ReferenceObjectTypes.WEBINAR_SETTING,
  [DSAssetFamilies.GOTO_WEBINAR_WEBINAR]: ReferenceObjectTypes.WEBINAR,
  [DSAssetFamilies.INTEGRATION]: ReferenceObjectTypes.INTEGRATION,
  [DSAssetFamilies.INTEGRATION_PROPERTY]: ReferenceObjectTypes.INTEGRATION_PROPERTY,
  [DSAssetFamilies.LINE_ITEM_PROPERTY]: ReferenceObjectTypes.LINE_ITEM_PROPERTY,
  [DSAssetFamilies.PRODUCT_PROPERTY]: ReferenceObjectTypes.PRODUCT_PROPERTY,
  [DSAssetFamilies.PROPERTY_GROUP]: ReferenceObjectTypes.PROPERTY_GROUP,
  [DSAssetFamilies.QUOTE_PROPERTY]: ReferenceObjectTypes.QUOTE_PROPERTY,
  [DSAssetFamilies.SURVEY_MONKEY_SURVEY]: ReferenceObjectTypes.SURVEY,
  [DSAssetFamilies.SURVEY_MONKEY_QUESTION]: ReferenceObjectTypes.SURVEY_QUESTION,
  [DSAssetFamilies.SURVEY_MONKEY_SETTING]: ReferenceObjectTypes.SURVEY_SETTING,
  [DSAssetFamilies.TICKET_PROPERTY]: ReferenceObjectTypes.TICKET_PROPERTY,
  [DSAssetFamilies.WORKFLOW]: ReferenceObjectTypes.ALL_WORKFLOW,
  [DSAssetFamilies.IN_LIST]: ReferenceObjectTypes.INBOUND_DB_LISTS
}, ObjectDefinitionProvider.getMapOf('objectTypeId', 'referenceObjectType'));
const DSAssetFamilyToReferenceObjectType = ImmutableMap(objectToReferenceType);
const getMissingFields = (assetFamily, data, getMissingFieldErrorMessage, requiredIds = []) => {
  if (assetFamily === DSAssetFamilies.INTEGRATION_PROPERTY) {
    return ImmutableMap();
  }
  const missingFields = requiredIds.reduce((acc, id) => !data.has(id) ? acc.set(id, MissingField({
    label: id,
    name: id,
    type: STRING,
    timestampType: NONE
  })) : acc, ImmutableMap());
  return getMissingFieldErrorMessage ? missingFields.map(field => field.set('errorMessage', getMissingFieldErrorMessage(assetFamily, field.id))) : missingFields;
};
const getFetchParams = (assetFamily, params = {}) => {
  const allParams = Object.assign({}, params);
  if (testDynamicFilterFamily(DSAssetFamilies.IN_LIST, assetFamily)) {
    allParams.listFilterProperties = {
      objectTypeId: parseDynamicFilterFamilyId(DSAssetFamilies.IN_LIST, assetFamily),
      includeDeletes: false
    };
  }
  return allParams;
};
const INTEGRATION_DATE = 'Date';
const INTEGRATION_DATE_TIME = 'DateTime';
export const getDataWithMutations = (data, assetFamily) => {
  if (assetFamily === DSAssetFamilies.INTEGRATION_PROPERTY) {
    return data.map(entry => {
      const properties = entry.getIn(['referencedObject', 'properties']);
      const adjustedProperties = properties.map(p => {
        // Integration dates are stored as DateTimes but the service labels them as Date
        // We need to overwrite the type to ensure the right behavior
        if (p.get('propertyType') === INTEGRATION_DATE) {
          return p.set('propertyType', INTEGRATION_DATE_TIME);
        }
        return p;
      });
      return entry.setIn(['referencedObject', 'properties'], adjustedProperties);
    });
  }
  return data;
};
const fetch = (resolver, params, assetFamily) => {
  const _getFetchParams = getFetchParams(assetFamily, params),
    {
      getMissingFieldErrorMessage,
      ids,
      hasMore,
      offset,
      query
    } = _getFetchParams,
    rest = _objectWithoutPropertiesLoose(_getFetchParams, _excluded);
  const referenceObjectType = DSAssetFamilyToReferenceObjectType.get(assetFamily);
  const lastQuery = getLastQuery(referenceObjectType, resolver);
  const queryChanged = isQueryChanged(query, lastQuery);
  const actualOffset = queryChanged ? 0 : offset;
  const actualHasMore = queryChanged ? true : hasMore;
  const handler = newAssets => {
    const isPaginated = isSearchResolver(resolver);
    if (ids && isPaginated) {
      if (ids.length === 0) {
        return {
          data: ImmutableMap(),
          hasMore,
          offset
        };
      }
      let data = indexBy(get('id'), List(newAssets)).filter(identity);
      data = getDataWithMutations(data, assetFamily);
      const missingData = getMissingFields(assetFamily, data, getMissingFieldErrorMessage, ids);
      return {
        data,
        hasMore,
        isHiddenFromSelect: referenceObjectType !== ReferenceObjectTypes.INTEGRATION_PROPERTY,
        missingData,
        offset
      };
    }
    lastQueries[referenceObjectType] = query;
    const parsedAssets = isPaginated ? newAssets.get('results') : newAssets;
    const newHasMore = isPaginated ? newAssets.get('hasMore') : false;

    // TODO: Try to fix this in r-r so we don't have a special case
    const newOffset = referenceObjectType === ReferenceObjectTypes.CTA ? newAssets.get('offset') + parsedAssets.size : newAssets.get('offset');
    const data = parsedAssets.filter(identity);
    const missingData = getMissingFields(assetFamily, indexBy(get('id'), List(parsedAssets)), getMissingFieldErrorMessage, ids);
    return {
      data,
      hasMore: newHasMore,
      isPaginated,
      missingData,
      offset: newOffset,
      queryChanged,
      updateImmediate: isPaginated
    };
  };
  if (isSearchResolver(resolver)) {
    if (ids) {
      const promises = ids.map(id => {
        return atomToPromise(resolver.byId(id));
      });
      return Promise.all(promises).then(handler);
    } else {
      return atomToPromise(resolver.search(Object.assign({
        hasMore: actualHasMore,
        offset: actualOffset,
        query: query || '',
        count: 100
      }, rest))).then(handler);
    }
  } else {
    return atomToPromise(resolver.all()).then(handler);
  }
};
const updater = ({
  data: newData,
  isHiddenFromSelect,
  isPaginated,
  missingData,
  queryChanged
}, prevData, assetFamily) => {
  const formattedNewData = isHiddenFromSelect ? toDSFieldRecord(newData, assetFamily).map(field => field.set('isHiddenFromSelect', true)) : toDSFieldRecord(newData, assetFamily);
  const formattedNewDataWithMissingData = formattedNewData.merge(missingData);
  if (isPaginated && queryChanged) {
    return prevData.map(field => field.set('isHiddenFromSelect', true)).merge(formattedNewDataWithMissingData);
  } else {
    return prevData.merge(formattedNewDataWithMissingData);
  }
};
const getFetcherFromProps = (assetFamily, props) => {
  const {
    referenceResolversByDSAssetFamily
  } = props;
  if (testDynamicFilterFamily(DSAssetFamilies.IN_LIST, assetFamily)) {
    return referenceResolversByDSAssetFamily[DSAssetFamilies.IN_LIST];
  }
  return referenceResolversByDSAssetFamily[assetFamily];
};
const isAssetFamilySupported = assetFamily => {
  const assetFamilyBasis = getDynamicFilterFamilyBasis(assetFamily);
  return DSAssetFamilyToReferenceObjectType.has(assetFamilyBasis || assetFamily);
};
const mapResolversToProps = resolvers => ({
  resolvers: ImmutableMap(resolvers),
  referenceResolversByDSAssetFamily: DSAssetFamilyToReferenceObjectType.map(referenceObjectType => resolvers[referenceObjectType]).toJS()
});
const defaultMergeResolvers = memoize((providedResolvers, connectedResolvers) => {
  if (!connectedResolvers) {
    return providedResolvers;
  }
  return Object.assign({}, providedResolvers, connectedResolvers);
});
const mergeResolvers = (providedResolvers, connectedResolvers, props) => {
  if (props.mergeResolvers) {
    return props.mergeResolvers(providedResolvers, connectedResolvers, props);
  }
  return defaultMergeResolvers(providedResolvers, connectedResolvers);
};
export const configureComponent = Component => {
  const connectedComponent = ConnectReferenceResolvers(mapResolversToProps, Component);
  return ProvideReferenceResolvers(resolverMap, connectedComponent, {
    mergeResolvers
  });
};
export default createDSAdapter({
  fetch,
  getFetcherFromProps,
  isAssetFamilySupported,
  updater
});